import { render, staticRenderFns } from "./Carrinho.vue?vue&type=template&id=1aee13bc"
import script from "./Carrinho.vue?vue&type=script&lang=js"
export * from "./Carrinho.vue?vue&type=script&lang=js"
import style0 from "./Carrinho.vue?vue&type=style&index=0&id=1aee13bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports